import { BASE_URL } from "constants/api.constant";
import ApiService from "./ApiService";

export async function apiGetClientData(data) {
  if (data === undefined) {
    return ApiService.fetchData({
      url: `${BASE_URL}clients`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.id) {
    return ApiService.fetchData({
      url: `${BASE_URL}client/${data.id}`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.reminderId) {
    return ApiService.fetchData({
      url: `${BASE_URL}clients/searchCriteria[pageSize]=10&searchCriteria[currentPage]=1&searchCriteria[filter_groups][0][filters][0][field]=id&searchCriteria[filter_groups][0][filters][0][value]=${data.reminderId}&searchCriteria[filter_groups][0][filters][0][condition_type]=eq&`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.search) {
    return ApiService.fetchData({
      url: `${BASE_URL}clients/searchCriteria[pageSize]=10&searchCriteria[currentPage]=1&searchCriteria[filter_groups][0][filters][0][field]=type&searchCriteria[filter_groups][0][filters][0][value]=medical,doctor,distributor&searchCriteria[filter_groups][0][filters][0][condition_type]=in&searchCriteria[filter_groups][1][filters][0][field]=name&searchCriteria[filter_groups][1][filters][0][value]=${data.search}&searchCriteria[filter_groups][1][filters][0][condition_type]=like&searchCriteria[filter_groups][2][filters][0][field]=status&searchCriteria[filter_groups][2][filters][0][value]=1&searchCriteria[filter_groups][2][filters][0][condition_type]=eq&`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.pageSize && !data.query && !data.sort.order) {
    return ApiService.fetchData({
      url: `${BASE_URL}clients/searchCriteria[pageSize]=${data.pageSize}&searchCriteria[currentPage]=${data.pageIndex}&searchCriteria[filter_groups][0][filters][0][field]=type&searchCriteria[filter_groups][0][filters][0][value]=MR&searchCriteria[filter_groups][0][filters][0][condition_type]=neq&searchCriteria[filter_groups][1][filters][0][field]=type&searchCriteria[filter_groups][1][filters][0][value]=Sales%20Manager&searchCriteria[filter_groups][1][filters][0][condition_type]=neq
      `,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.sort.order && !data.query) {
    return ApiService.fetchData({
      url: `${BASE_URL}clients/searchCriteria[pageSize]=${data.pageSize}&searchCriteria[currentPage]=${data.pageIndex}&searchCriteria[sortOrders][0][fields]=${data.sort.key}&searchCriteria[sortOrders][0][direction]=${data.sort.order}&searchCriteria[filter_groups][0][filters][0][field]=type&searchCriteria[filter_groups][0][filters][0][value]=MR&searchCriteria[filter_groups][0][filters][0][condition_type]=neq`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.sort.order && !data.query) {
    return ApiService.fetchData({
      url: `${BASE_URL}clients/searchCriteria[pageSize]=${data.pageSize}&searchCriteria[currentPage]=${data.pageIndex}&searchCriteria[sortOrders][0][fields]=${data.sort.key}&searchCriteria[sortOrders][0][direction]=${data.sort.order}&searchCriteria[filter_groups][0][filters][0][field]=type&searchCriteria[filter_groups][0][filters][0][value]=MR&searchCriteria[filter_groups][0][filters][0][condition_type]=neq`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
    // Query has been change as some field are removed
  } else if (data.query && !data.sort.order) {
    return ApiService.fetchData({
      url: `${BASE_URL}clients/searchCriteria[pageSize]=${data.pageSize}&searchCriteria[currentPage]=${data.pageIndex}&searchCriteria[filter_groups][0][filters][0][field]=id&searchCriteria[filter_groups][0][filters][0][value]=${data.query}&searchCriteria[filter_groups][0][filters][0][condition_type]=like&searchCriteria[filter_groups][0][filters][1][field]=name&searchCriteria[filter_groups][0][filters][1][value]=${data.query}&searchCriteria[filter_groups][0][filters][1][condition_type]=like&searchCriteria[filter_groups][0][filters][2][field]=email&searchCriteria[filter_groups][0][filters][2][value]=${data.query}&searchCriteria[filter_groups][0][filters][2][condition_type]=like&searchCriteria[filter_groups][0][filters][3][field]=phone&searchCriteria[filter_groups][0][filters][3][value]=${data.query}&searchCriteria[filter_groups][0][filters][3][condition_type]=like&searchCriteria[filter_groups][0][filters][4][field]=area&searchCriteria[filter_groups][0][filters][4][value]=${data.query}&searchCriteria[filter_groups][0][filters][4][condition_type]=like&searchCriteria[filter_groups][0][filters][5][field]=type&searchCriteria[filter_groups][0][filters][5][value]=${data.query}&searchCriteria[filter_groups][0][filters][5][condition_type]=like&searchCriteria[filter_groups][0][filters][6][field]=pan_gst&searchCriteria[filter_groups][0][filters][6][value]=${data.query}&searchCriteria[filter_groups][0][filters][6][condition_type]=like&searchCriteria[filter_groups][0][filters][7][field]=address&searchCriteria[filter_groups][0][filters][7][value]=${data.query}&searchCriteria[filter_groups][0][filters][7][condition_type]=like&searchCriteria[filter_groups][0][filters][8][field]=notification&searchCriteria[filter_groups][0][filters][8][value]=${data.query}&searchCriteria[filter_groups][0][filters][8][condition_type]=like&searchCriteria[filter_groups][0][filters][9][field]=created_by_name&searchCriteria[filter_groups][0][filters][9][value]=${data.query}&searchCriteria[filter_groups][0][filters][9][condition_type]=like&searchCriteria[filter_groups][1][filters][0][field]=type&searchCriteria[filter_groups][1][filters][0][value]=MR&searchCriteria[filter_groups][1][filters][0][condition_type]=neq`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
    // Query has been change as some field are removed
  } else if (data.query) {
    return ApiService.fetchData({
      url: `${BASE_URL}clients/searchCriteria[pageSize]=${data.pageSize}&searchCriteria[currentPage]=${data.pageIndex}&searchCriteria[sortOrders][0][fields]=${data.sort.key}&searchCriteria[sortOrders][0][direction]=${data.sort.order}&searchCriteria[filter_groups][0][filters][0][field]=id&searchCriteria[filter_groups][0][filters][0][value]=${data.query}&searchCriteria[filter_groups][0][filters][0][condition_type]=like&searchCriteria[filter_groups][0][filters][1][field]=name&searchCriteria[filter_groups][0][filters][1][value]=${data.query}&searchCriteria[filter_groups][0][filters][1][condition_type]=like&searchCriteria[filter_groups][0][filters][2][field]=email&searchCriteria[filter_groups][0][filters][2][value]=${data.query}&searchCriteria[filter_groups][0][filters][2][condition_type]=like&searchCriteria[filter_groups][0][filters][3][field]=phone&searchCriteria[filter_groups][0][filters][3][value]=${data.query}&searchCriteria[filter_groups][0][filters][3][condition_type]=like&searchCriteria[filter_groups][0][filters][4][field]=area&searchCriteria[filter_groups][0][filters][4][value]=${data.query}&searchCriteria[filter_groups][0][filters][4][condition_type]=like&searchCriteria[filter_groups][0][filters][5][field]=type&searchCriteria[filter_groups][0][filters][5][value]=${data.query}&searchCriteria[filter_groups][0][filters][5][condition_type]=like&searchCriteria[filter_groups][0][filters][6][field]=pan_gst&searchCriteria[filter_groups][0][filters][6][value]=${data.query}&searchCriteria[filter_groups][0][filters][6][condition_type]=like&searchCriteria[filter_groups][0][filters][7][field]=address&searchCriteria[filter_groups][0][filters][7][value]=${data.query}&searchCriteria[filter_groups][0][filters][7][condition_type]=like&searchCriteria[filter_groups][0][filters][8][field]=created_by_name&searchCriteria[filter_groups][0][filters][8][value]=${data.query}&searchCriteria[filter_groups][0][filters][8][condition_type]=like&searchCriteria[filter_groups][1][filters][0][field]=type&searchCriteria[filter_groups][1][filters][0][value]=MR&searchCriteria[filter_groups][1][filters][0][condition_type]=neq`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  }
}

export async function apiGetClientTrashData(data) {
  if (data === undefined) {
    return ApiService.fetchData({
      url: `${BASE_URL}client/trashed`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.pageSize && !data.query && !data.sort.order) {
    return ApiService.fetchData({
      url: `${BASE_URL}client/trashed/searchCriteria[pageSize]=${data.pageSize}&searchCriteria[currentPage]=${data.pageIndex}`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.sort.order && !data.query) {
    return ApiService.fetchData({
      url: `${BASE_URL}client/trashed/searchCriteria[pageSize]=${data.pageSize}&searchCriteria[currentPage]=${data.pageIndex}&searchCriteria[sortOrders][0][fields]=${data.sort.key}&searchCriteria[sortOrders][0][direction]=${data.sort.order}`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.query && !data.sort.order) {
    return ApiService.fetchData({
      url: `${BASE_URL}client/trashed/searchCriteria[pageSize]=${data.pageSize}&searchCriteria[currentPage]=${data.pageIndex}&
      searchCriteria[filter_groups][0][filters][0][field]=id&
      searchCriteria[filter_groups][0][filters][0][value]=${data.query}&searchCriteria[filter_groups][0][filters][0][condition_type]=like&
      searchCriteria[filter_groups][0][filters][1][field]=name&
      searchCriteria[filter_groups][0][filters][1][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][1][condition_type]=like&
      searchCriteria[filter_groups][0][filters][2][field]=email&searchCriteria[filter_groups][0][filters][2][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][2][condition_type]=like&
      searchCriteria[filter_groups][0][filters][3][field]=phone&
      searchCriteria[filter_groups][0][filters][3][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][3][condition_type]=like&
      searchCriteria[filter_groups][0][filters][4][field]=area&
      searchCriteria[filter_groups][0][filters][4][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][4][condition_type]=like&
      searchCriteria[filter_groups][0][filters][5][field]=type&
      searchCriteria[filter_groups][0][filters][5][value]=${data.query}&searchCriteria[filter_groups][0][filters][5][condition_type]=like&
      searchCriteria[filter_groups][0][filters][6][field]=pan_gst&
      searchCriteria[filter_groups][0][filters][6][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][6][condition_type]=like&
      searchCriteria[filter_groups][0][filters][7][field]=zip&
      searchCriteria[filter_groups][0][filters][7][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][7][condition_type]=like&
      searchCriteria[filter_groups][0][filters][8][field]=address&
      searchCriteria[filter_groups][0][filters][8][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][8][condition_type]=like&
      searchCriteria[filter_groups][0][filters][9][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][9][field]=mobile&
      searchCriteria[filter_groups][0][filters][9][condition_type]=like&
      searchCriteria[filter_groups][0][filters][10][field]=notification&
      searchCriteria[filter_groups][0][filters][10][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][10][condition_type]=like&`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  } else if (data.query) {
    return ApiService.fetchData({
      url: `${BASE_URL}client/trashed/searchCriteria[pageSize]=${data.pageSize}&searchCriteria[currentPage]=${data.pageIndex}&
      searchCriteria[filter_groups][0][filters][0][field]=id&
      searchCriteria[filter_groups][0][filters][0][value]=${data.query}&searchCriteria[filter_groups][0][filters][0][condition_type]=like&
      searchCriteria[filter_groups][0][filters][1][field]=name&
      searchCriteria[filter_groups][0][filters][1][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][1][condition_type]=like&
      searchCriteria[filter_groups][0][filters][2][field]=email&searchCriteria[filter_groups][0][filters][2][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][2][condition_type]=like&
      searchCriteria[filter_groups][0][filters][3][field]=phone&
      searchCriteria[filter_groups][0][filters][3][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][3][condition_type]=like&
      searchCriteria[filter_groups][0][filters][4][field]=area&
      searchCriteria[filter_groups][0][filters][4][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][4][condition_type]=like&
      searchCriteria[filter_groups][0][filters][5][field]=type&
      searchCriteria[filter_groups][0][filters][5][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][5][condition_type]=like&
      searchCriteria[filter_groups][0][filters][6][field]=pan_gst&
      searchCriteria[filter_groups][0][filters][6][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][6][condition_type]=like&
      searchCriteria[filter_groups][0][filters][7][field]=zip&
      searchCriteria[filter_groups][0][filters][7][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][7][condition_type]=like&
      searchCriteria[filter_groups][0][filters][8][field]=address&
      searchCriteria[filter_groups][0][filters][8][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][8][condition_type]=like&
      searchCriteria[filter_groups][0][filters][9][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][9][field]=mobile&
      searchCriteria[filter_groups][0][filters][9][condition_type]=like&
      searchCriteria[filter_groups][0][filters][10][field]=notification&
      searchCriteria[filter_groups][0][filters][10][value]=${data.query}&
      searchCriteria[filter_groups][0][filters][10][condition_type]=like&`,
      method: "get",
    }).catch((e) => {
      return e.response;
    });
  }
}

export async function apiPostClient(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}client`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    },
    data,
  });
}

export async function apiChangeStatusClient(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}client/status`,
    method: "put",
    data,
  });
}

export async function apiPutClient(data, id) {
  // console.log("Inside put client", data);
  return ApiService.fetchData({
    url: `${BASE_URL}client/${id}`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    },
    data,
  });
}

export async function apiRecoverClient(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}client/recover`,
    method: "post",
    data,
  });
}

export async function apiDeleteClient(data) {
  return ApiService.fetchData({
    url: `${BASE_URL}client`,
    method: "delete",
    data,
  });
}
